"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurHub() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}